var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.suppliers,"offset-y":"","item-text":"item2","item-value":"item1","auto-select-first":"","rules":[_vm.rules.required],"required":"","placeholder":"Kies leverancier","dense":""},model:{value:(_vm.txt_supplier),callback:function ($$v) {_vm.txt_supplier=$$v},expression:"txt_supplier"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }